import "./RefundReturnPolicy.css";
import { VERSION } from "../../constants";
import Breadcrums from "../../components/breadcrums/Breadcrums";
import Breadcrumsv2 from "../../components/breadcrums_v2/Breadcrums";

const BreadcrumsDynamic = VERSION === "1" ? Breadcrums : Breadcrumsv2;

const RefundReturnPolicy = () => {
  return (
    <div className="refundreturnpolicy">
      <BreadcrumsDynamic />

      <div className="refundreturnpolicy-content">
        <div className="refundreturnpolicy-main">
          <div className="rrp-subtitle">1. APPLICATION FOR REFUNDS/RETURNS</div>
          <div className="rrp-descrip">
            <strong>1.1</strong> - Subject to the terms and condition in this
            Refunds and Returns Policy and the Terms of Service, Buyer may apply
            for return of the purchased items (“item”) and/or refund prior to
            the expiry of the Unity 7 Days Easy Return as stated in the Terms of
            Service.
            <br />
            <strong>1.2</strong> - Unity 7 Days Easy Return is a service
            provided by Unity, on User's request, to assist Users in dealing
            with certain conflicts which may arise during the course of
            transaction. Users may communicate with Customer Service to assist
            them in overcoming any dispute prior, during or after the Unity 7
            Days Easy Return.
          </div>

          <div className="rrp-subtitle">
            2. APPLICATION FOR THE RETURN OF AN ITEM
          </div>
          <div className="rrp-descrip">
            <strong>2.1</strong> - Buyer may only apply for the refund and/or
            return of the item in the following circumstances:
          </div>
          <ul className="rrp-list">
            <li>The item has not been received by Buyer;</li>
            <li>The item was defective and/or damaged on delivery;</li>
            <li>
              The item received is incomplete (missing quantity or accessories);
            </li>
            <li>
              Seller has delivered an item that does not match the agreed
              specification (e.g. wrong size, colour, etc.) to Buyer;
            </li>
            <li>
              The item delivered to Buyer is materially different from the
              description provided by Seller in the listing of the item;
            </li>
            <li>The item received is a counterfeit item;</li>
            <li>
              The item received has physical damage (e.g. dented, scratched,
              shattered);
            </li>
            <li>
              By way of private agreement with Seller and Seller must send
              his/her confirmation to Unity confirming such agreement;
            </li>
          </ul>
          <div className="rrp-descrip">
            <strong>2.2</strong> - Buyer's application must be submitted via the
            Unity website.
            <br />
            <strong>2.3</strong> - Unity will review each Buyer's application on
            a case-by-case basis and, in its sole discretion, determine whether
            Buyer's application is successful.
            <br />
            <strong>2.4</strong> - Unity will arrange the collection time with
            Buyer after the refund/return request has been approved.
            <br />
            <strong>2.5</strong> - The approval of your request for refund and
            return will be made by Unity in its sole discretion. Buyer
            acknowledges and agrees that Unity's decision is final, conclusive
            and binding, and covenants and agrees that it will not bring suit or
            otherwise assert any claim against Unity or its affiliates in
            relation to such decision.
          </div>

          <div className="rrp-subtitle">3. CONDITIONS OF RETURNING ITEM</div>
          <div className="rrp-descrip">
            To enjoy a hassle-free experience when returning the item, Buyer
            should ensure that the item, including any complimentary items such
            as accessories that come with the item, must be returned to Seller
            in the condition received by Buyer on delivery. We will recommend
            Buyer to take a photo of the item upon receipt.
          </div>

          <div className="rrp-subtitle">4. APPLICATION FOR REFUNDS/RETURNS</div>
          <div className="rrp-descrip">
            (a) In the scenario of an unforeseen error from the seller's end
            (i.e. damaged, faulty or wrong item delivered to the Buyer), the
            seller will bear Buyer's return shipping fee.
            <br />
            (b) In the scenario of the Buyer's change of mind, Buyer shall get
            seller's consent prior to the return request and Buyer will bear the
            return shipping fee.
          </div>

          <div className="rrp-subtitle">5. REFUNDS</div>
          <div className="rrp-descrip">
            <strong>5.1</strong> - Buyer will only be refunded after Unity has
            received the returned item. The refund will be made to Buyer's
            designated bank account.
            <br />
            <strong>5.2</strong> - In cases where there is no way to fix/repair
            the item, Unity will proceed to issue refund to Buyer.
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundReturnPolicy;
